import { AUTH, ROUTE } from '@/constants';
import { loadView } from '../index';

const DashboardView = loadView('dashboard/DashboardView');

const dashboardRoute = {
  path: ROUTE.PATH.DASHBOARD,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.DASHBOARD,
      component: DashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
      },
    },
  ],
};

export default dashboardRoute;
